<template>
  <div class="container">
    <div>
      <div class="d-flex align-items-center justify-content-between">
        <p class="robo-24-500 txt-black mb-3">{{$t('multidisciplinary_board.lbl_lab_exam')}}</p>

        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="cursor-pointer"
          @click="onClose"
        >
          <path
            d="M6 18.4998L17.9998 6.5"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M17.9998 18.4998L6 6.5"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
    <!-- item -->
    <div class="row">
      <div
        class="col-xl-3 col-lg-4 col-sm-6 mb-3"
        @click="modalUpload(true)"
      >
        <div class="item-doc">
          <div class="item-doc-thumb ratio ratio-16x9">
            <div class="d-flex h-100 justify-content-center align-items-center">
              <img
                src="../../../public/assets/images/MDT/upload-doc.svg"
                width="64"
                height="64"
                alt=""
              />
            </div>
          </div>
          <div class="item-doc-info px-3">
            <button class="btn bg-pri bd-pri text-white robo-10-400 mb-0 w-100">
              <svg
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="5.42773"
                  y="5.95605"
                  width="6.80812"
                  height="7.56458"
                  fill="#20419B"
                />
                <path
                  d="M9.21008 2.17383C5.03444 2.17383 1.64551 5.56276 1.64551 9.7384C1.64551 13.914 5.03444 17.303 9.21008 17.303C13.3857 17.303 16.7747 13.914 16.7747 9.7384C16.7747 5.56276 13.3857 2.17383 9.21008 2.17383ZM11.8804 9.7611C11.7669 9.87457 11.6232 9.92752 11.4795 9.92752C11.3357 9.92752 11.192 9.87457 11.0785 9.7611L9.77743 8.45999V12.386C9.77743 12.6962 9.52023 12.9533 9.21008 12.9533C8.89994 12.9533 8.64274 12.6962 8.64274 12.386V8.45999L7.34163 9.7611C7.12226 9.98047 6.75916 9.98047 6.53979 9.7611C6.32042 9.54172 6.32042 9.17863 6.53979 8.95925L8.80916 6.68988C9.02853 6.47051 9.39163 6.47051 9.61101 6.68988L11.8804 8.95925C12.0998 9.17863 12.0998 9.54172 11.8804 9.7611Z"
                  fill="white"
                />
              </svg>
              {{$t('multidisciplinary_board.lbl_upload')}}
            </button>
          </div>
        </div>
      </div>
      <div
        v-if="isOwner"
        class="col-xl-3 col-lg-4 col-sm-6 mb-3"
        @click="modalCreateLink(true)"
      >
        <div class="item-doc">
          <div class="item-doc-thumb ratio ratio-16x9">
            <div class="d-flex h-100 justify-content-center align-items-center">
              <svg
                width="64"
                height="64"
                viewBox="0 0 95 96"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_dd_20410_90112)">
                  <path
                    d="M36.3034 27.9993C39.8159 27.9993 43.1259 28.7531 46.2559 30.2506C48.6022 31.3581 50.7209 32.8656 52.6284 34.7631C54.4885 36.6086 56.0152 38.762 57.1409 41.1281C55.6347 42.6356 53.8222 43.3793 51.7034 43.3793C50.9411 43.3746 50.1832 43.2622 49.4522 43.0456C48.1688 40.9659 46.4172 39.2147 44.3372 37.9319C41.9251 36.4474 39.1457 35.6675 36.3134 35.6806C34.3097 35.6806 32.3634 36.0619 30.4834 36.8256C28.5917 37.5967 26.8752 38.7421 25.4372 40.1931L13.8922 51.7381C12.4406 53.1764 11.2948 54.8933 10.5234 56.7856C9.76816 58.6361 9.3793 60.6156 9.37843 62.6143C9.37843 64.6181 9.76094 66.5644 10.5234 68.4444C11.2889 70.3398 12.4355 72.0578 13.8922 73.4919C15.3297 74.944 17.0468 76.0896 18.9397 76.8594C20.7897 77.6131 22.7747 78.0044 24.7784 78.0044C26.7822 78.0044 28.7284 77.6231 30.6084 76.8594C32.5002 76.0883 34.2166 74.9428 35.6547 73.4919L43.7372 65.4106C46.3034 66.1068 48.9559 66.4606 51.7034 66.4606C52.1422 66.4606 52.7622 66.4406 53.5634 66.4031C53.26 66.7381 52.9517 67.0685 52.6384 67.3943L41.0934 78.9393C38.8709 81.1631 36.3522 82.8419 33.5272 83.9868C27.9123 86.2788 21.622 86.2752 16.0097 83.9768C13.1757 82.8213 10.6028 81.1082 8.44343 78.9393C6.22093 76.7169 4.54219 74.1981 3.39719 71.3831C2.2618 68.6026 1.67845 65.6277 1.67969 62.6244C1.67969 59.6194 2.26094 56.6419 3.39719 53.8656C4.54219 51.0506 6.22093 48.5318 8.44343 46.3093L19.9884 34.7643C20.2084 34.5443 20.5422 34.2393 20.9809 33.8293C23.0861 31.9494 25.5226 30.4773 28.1659 29.4881C30.7685 28.5128 33.5241 28.0091 36.3034 28.0006V27.9993ZM63.2384 1.07435C66.2447 1.07435 69.2209 1.65685 71.9972 2.79185C74.8122 3.92685 77.3309 5.61685 79.5634 7.83935C81.7872 10.0618 83.4759 12.5806 84.6109 15.3956C85.7467 18.1756 86.3268 21.1513 86.3184 24.1543C86.3184 27.1593 85.7372 30.0793 84.5922 32.9131C83.4387 35.7452 81.7253 38.3153 79.5547 40.4694L68.0097 52.0143C67.7897 52.2431 67.4559 52.5494 67.0172 52.9493C64.9149 54.8333 62.4777 56.3058 59.8322 57.2906C57.2283 58.2738 54.468 58.7778 51.6847 58.7781C48.2401 58.7903 44.8377 58.021 41.7334 56.5281C39.3859 55.4206 37.2672 53.9131 35.3584 52.0156C33.4984 50.1701 31.9717 48.0167 30.8459 45.6506C32.3447 44.1431 34.1584 43.3993 36.2847 43.3993C37.0297 43.3993 37.7834 43.5131 38.5372 43.7331C39.8165 45.8122 41.5643 47.5634 43.6409 48.8468C46.0539 50.3304 48.8334 51.1101 51.6659 51.0981C53.6684 51.0981 55.6159 50.7168 57.4947 49.9531C59.3881 49.1845 61.1055 48.0388 62.5422 46.5856L74.0872 35.0406C75.5414 33.6047 76.6873 31.8872 77.4547 29.9931C78.2084 28.1431 78.5997 26.1681 78.5997 24.1643C78.5997 22.1606 78.2184 20.2143 77.4547 18.3344C76.6861 16.4409 75.5404 14.7236 74.0872 13.2868C72.6496 11.8347 70.9325 10.6891 69.0397 9.91935C67.1885 9.1648 65.2087 8.77597 63.2097 8.77435C61.2059 8.77435 59.2597 9.1556 57.3809 9.91935C55.4875 10.6879 53.7701 11.8337 52.3334 13.2868L44.2422 21.3681C41.6452 20.6656 38.9662 20.3125 36.2759 20.3181C35.8359 20.3181 35.2159 20.3381 34.4147 20.3756C34.7197 20.0418 35.0259 19.7081 35.3497 19.3843L46.8947 7.83935C49.0487 5.66872 51.6188 3.95532 54.4509 2.80184C57.3047 1.64684 60.2234 1.06435 63.2384 1.07435Z"
                    fill="#20419B"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_dd_20410_90112"
                    x="0.679688"
                    y="0.0742188"
                    width="93.6387"
                    height="95.6289"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dx="4" dy="6" />
                    <feGaussianBlur stdDeviation="2" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_20410_90112"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="0.5" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="effect1_dropShadow_20410_90112"
                      result="effect2_dropShadow_20410_90112"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect2_dropShadow_20410_90112"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </div>
          </div>
          <div class="item-doc-info px-3">
            <button class="btn bg-pri bd-pri text-white robo-10-400 mb-0 w-100">
              <svg
                width="95"
                height="96"
                viewBox="0 0 95 96"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_dd_20410_90112)">
                  <path
                    d="M36.3034 27.9993C39.8159 27.9993 43.1259 28.7531 46.2559 30.2506C48.6022 31.3581 50.7209 32.8656 52.6284 34.7631C54.4885 36.6086 56.0152 38.762 57.1409 41.1281C55.6347 42.6356 53.8222 43.3793 51.7034 43.3793C50.9411 43.3746 50.1832 43.2622 49.4522 43.0456C48.1688 40.9659 46.4172 39.2147 44.3372 37.9319C41.9251 36.4474 39.1457 35.6675 36.3134 35.6806C34.3097 35.6806 32.3634 36.0619 30.4834 36.8256C28.5917 37.5967 26.8752 38.7421 25.4372 40.1931L13.8922 51.7381C12.4406 53.1764 11.2948 54.8933 10.5234 56.7856C9.76816 58.6361 9.3793 60.6156 9.37843 62.6143C9.37843 64.6181 9.76094 66.5644 10.5234 68.4444C11.2889 70.3398 12.4355 72.0578 13.8922 73.4919C15.3297 74.944 17.0468 76.0896 18.9397 76.8594C20.7897 77.6131 22.7747 78.0044 24.7784 78.0044C26.7822 78.0044 28.7284 77.6231 30.6084 76.8594C32.5002 76.0883 34.2166 74.9428 35.6547 73.4919L43.7372 65.4106C46.3034 66.1068 48.9559 66.4606 51.7034 66.4606C52.1422 66.4606 52.7622 66.4406 53.5634 66.4031C53.26 66.7381 52.9517 67.0685 52.6384 67.3943L41.0934 78.9393C38.8709 81.1631 36.3522 82.8419 33.5272 83.9868C27.9123 86.2788 21.622 86.2752 16.0097 83.9768C13.1757 82.8213 10.6028 81.1082 8.44343 78.9393C6.22093 76.7169 4.54219 74.1981 3.39719 71.3831C2.2618 68.6026 1.67845 65.6277 1.67969 62.6244C1.67969 59.6194 2.26094 56.6419 3.39719 53.8656C4.54219 51.0506 6.22093 48.5318 8.44343 46.3093L19.9884 34.7643C20.2084 34.5443 20.5422 34.2393 20.9809 33.8293C23.0861 31.9494 25.5226 30.4773 28.1659 29.4881C30.7685 28.5128 33.5241 28.0091 36.3034 28.0006V27.9993ZM63.2384 1.07435C66.2447 1.07435 69.2209 1.65685 71.9972 2.79185C74.8122 3.92685 77.3309 5.61685 79.5634 7.83935C81.7872 10.0618 83.4759 12.5806 84.6109 15.3956C85.7467 18.1756 86.3268 21.1513 86.3184 24.1543C86.3184 27.1593 85.7372 30.0793 84.5922 32.9131C83.4387 35.7452 81.7253 38.3153 79.5547 40.4694L68.0097 52.0143C67.7897 52.2431 67.4559 52.5494 67.0172 52.9493C64.9149 54.8333 62.4777 56.3058 59.8322 57.2906C57.2283 58.2738 54.468 58.7778 51.6847 58.7781C48.2401 58.7903 44.8377 58.021 41.7334 56.5281C39.3859 55.4206 37.2672 53.9131 35.3584 52.0156C33.4984 50.1701 31.9717 48.0167 30.8459 45.6506C32.3447 44.1431 34.1584 43.3993 36.2847 43.3993C37.0297 43.3993 37.7834 43.5131 38.5372 43.7331C39.8165 45.8122 41.5643 47.5634 43.6409 48.8468C46.0539 50.3304 48.8334 51.1101 51.6659 51.0981C53.6684 51.0981 55.6159 50.7168 57.4947 49.9531C59.3881 49.1845 61.1055 48.0388 62.5422 46.5856L74.0872 35.0406C75.5414 33.6047 76.6873 31.8872 77.4547 29.9931C78.2084 28.1431 78.5997 26.1681 78.5997 24.1643C78.5997 22.1606 78.2184 20.2143 77.4547 18.3344C76.6861 16.4409 75.5404 14.7236 74.0872 13.2868C72.6496 11.8347 70.9325 10.6891 69.0397 9.91935C67.1885 9.1648 65.2087 8.77597 63.2097 8.77435C61.2059 8.77435 59.2597 9.1556 57.3809 9.91935C55.4875 10.6879 53.7701 11.8337 52.3334 13.2868L44.2422 21.3681C41.6452 20.6656 38.9662 20.3125 36.2759 20.3181C35.8359 20.3181 35.2159 20.3381 34.4147 20.3756C34.7197 20.0418 35.0259 19.7081 35.3497 19.3843L46.8947 7.83935C49.0487 5.66872 51.6188 3.95532 54.4509 2.80184C57.3047 1.64684 60.2234 1.06435 63.2384 1.07435Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_dd_20410_90112"
                    x="0.679688"
                    y="0.0742188"
                    width="93.6387"
                    height="95.6289"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dx="4" dy="6" />
                    <feGaussianBlur stdDeviation="2" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_20410_90112"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="0.5" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="effect1_dropShadow_20410_90112"
                      result="effect2_dropShadow_20410_90112"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect2_dropShadow_20410_90112"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>

              {{$t('multidisciplinary_board.lbl_create_link')}}
            </button>
          </div>
        </div>
      </div>

      <div
        class="col-xl-3 col-lg-4 col-sm-6 mb-3 position-relative"
        v-for="(doc, i) in docAttachments"
        :key="doc.id + '-' + i"
      >
        <div
          class="item-doc"
          :set="[(extInfo = getExtInfo(doc))]"
          @click="openDocAttach(doc)"
        >
        <div v-if="doc.type == 1">
          <div
            v-if="extInfo.is_image"
            class="item-doc-thumb ratio ratio-16x9 radius-top-10"
            :style="{ 'background-image': 'url(' + doc.url + ')' }"
          ></div>
          <div
            v-if="!extInfo.is_image"
            class="item-doc-thumb ratio ratio-16x9 radius-10"
          >
            <div class="d-flex h-100 justify-content-center align-items-center">
              <p class="mb-0 robo-34-700 txt-pri text-uppercase">
                {{ extInfo.ext }}
              </p>
            </div>
          </div>

        </div>
        <div v-if="doc.type == 2">
          <div
            class="item-doc-thumb ratio ratio-16x9 radius-10"
          >
            <div class="d-flex h-100 justify-content-center align-items-center">
              <svg
                width="64"
                height="64"
                viewBox="0 0 95 96"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_dd_20410_90112)">
                  <path
                    d="M36.3034 27.9993C39.8159 27.9993 43.1259 28.7531 46.2559 30.2506C48.6022 31.3581 50.7209 32.8656 52.6284 34.7631C54.4885 36.6086 56.0152 38.762 57.1409 41.1281C55.6347 42.6356 53.8222 43.3793 51.7034 43.3793C50.9411 43.3746 50.1832 43.2622 49.4522 43.0456C48.1688 40.9659 46.4172 39.2147 44.3372 37.9319C41.9251 36.4474 39.1457 35.6675 36.3134 35.6806C34.3097 35.6806 32.3634 36.0619 30.4834 36.8256C28.5917 37.5967 26.8752 38.7421 25.4372 40.1931L13.8922 51.7381C12.4406 53.1764 11.2948 54.8933 10.5234 56.7856C9.76816 58.6361 9.3793 60.6156 9.37843 62.6143C9.37843 64.6181 9.76094 66.5644 10.5234 68.4444C11.2889 70.3398 12.4355 72.0578 13.8922 73.4919C15.3297 74.944 17.0468 76.0896 18.9397 76.8594C20.7897 77.6131 22.7747 78.0044 24.7784 78.0044C26.7822 78.0044 28.7284 77.6231 30.6084 76.8594C32.5002 76.0883 34.2166 74.9428 35.6547 73.4919L43.7372 65.4106C46.3034 66.1068 48.9559 66.4606 51.7034 66.4606C52.1422 66.4606 52.7622 66.4406 53.5634 66.4031C53.26 66.7381 52.9517 67.0685 52.6384 67.3943L41.0934 78.9393C38.8709 81.1631 36.3522 82.8419 33.5272 83.9868C27.9123 86.2788 21.622 86.2752 16.0097 83.9768C13.1757 82.8213 10.6028 81.1082 8.44343 78.9393C6.22093 76.7169 4.54219 74.1981 3.39719 71.3831C2.2618 68.6026 1.67845 65.6277 1.67969 62.6244C1.67969 59.6194 2.26094 56.6419 3.39719 53.8656C4.54219 51.0506 6.22093 48.5318 8.44343 46.3093L19.9884 34.7643C20.2084 34.5443 20.5422 34.2393 20.9809 33.8293C23.0861 31.9494 25.5226 30.4773 28.1659 29.4881C30.7685 28.5128 33.5241 28.0091 36.3034 28.0006V27.9993ZM63.2384 1.07435C66.2447 1.07435 69.2209 1.65685 71.9972 2.79185C74.8122 3.92685 77.3309 5.61685 79.5634 7.83935C81.7872 10.0618 83.4759 12.5806 84.6109 15.3956C85.7467 18.1756 86.3268 21.1513 86.3184 24.1543C86.3184 27.1593 85.7372 30.0793 84.5922 32.9131C83.4387 35.7452 81.7253 38.3153 79.5547 40.4694L68.0097 52.0143C67.7897 52.2431 67.4559 52.5494 67.0172 52.9493C64.9149 54.8333 62.4777 56.3058 59.8322 57.2906C57.2283 58.2738 54.468 58.7778 51.6847 58.7781C48.2401 58.7903 44.8377 58.021 41.7334 56.5281C39.3859 55.4206 37.2672 53.9131 35.3584 52.0156C33.4984 50.1701 31.9717 48.0167 30.8459 45.6506C32.3447 44.1431 34.1584 43.3993 36.2847 43.3993C37.0297 43.3993 37.7834 43.5131 38.5372 43.7331C39.8165 45.8122 41.5643 47.5634 43.6409 48.8468C46.0539 50.3304 48.8334 51.1101 51.6659 51.0981C53.6684 51.0981 55.6159 50.7168 57.4947 49.9531C59.3881 49.1845 61.1055 48.0388 62.5422 46.5856L74.0872 35.0406C75.5414 33.6047 76.6873 31.8872 77.4547 29.9931C78.2084 28.1431 78.5997 26.1681 78.5997 24.1643C78.5997 22.1606 78.2184 20.2143 77.4547 18.3344C76.6861 16.4409 75.5404 14.7236 74.0872 13.2868C72.6496 11.8347 70.9325 10.6891 69.0397 9.91935C67.1885 9.1648 65.2087 8.77597 63.2097 8.77435C61.2059 8.77435 59.2597 9.1556 57.3809 9.91935C55.4875 10.6879 53.7701 11.8337 52.3334 13.2868L44.2422 21.3681C41.6452 20.6656 38.9662 20.3125 36.2759 20.3181C35.8359 20.3181 35.2159 20.3381 34.4147 20.3756C34.7197 20.0418 35.0259 19.7081 35.3497 19.3843L46.8947 7.83935C49.0487 5.66872 51.6188 3.95532 54.4509 2.80184C57.3047 1.64684 60.2234 1.06435 63.2384 1.07435Z"
                    fill="#20419B"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_dd_20410_90112"
                    x="0.679688"
                    y="0.0742188"
                    width="93.6387"
                    height="95.6289"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dx="4" dy="6" />
                    <feGaussianBlur stdDeviation="2" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_20410_90112"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="0.5" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="effect1_dropShadow_20410_90112"
                      result="effect2_dropShadow_20410_90112"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect2_dropShadow_20410_90112"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </div>
          </div>

        </div>
          <div class="item-doc-info p-3">
            <p class="txt-black robo-14-400 mb-1 max-line-1">{{ doc.name }}</p>
            <p class="txt-black robo-12-400 mb-1 max-line-1">
              {{ formatDMY(doc.created_at) }}
            </p>
          </div>
        </div>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="delete-btn"
          @click="deleteDoc(doc)"
        >
          <path
            d="M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM8 9H16V19H8V9ZM15.5 4L14.5 3H9.5L8.5 4H5V6H19V4H15.5Z"
            fill="#FA0303"
          />
        </svg>
      </div>
    </div>
    <!-- item -->

    <!-- Modal -->
    <div
      class="modal fade"
      id="modalUpload"
      tabindex="-1"
      aria-labelledby="modalUploadTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content" :set="(count = selected_docs.length)">
          <div class="modal-header border-0 bg-white">
            <h5 class="modal-title robo-12-500 txt-black" id="modalUploadTitle">
              {{$t('multidisciplinary_board.lbl_choose')}}
            </h5>
            <!-- <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button> -->
          </div>
          <div class="modal-body">
            <label class="robo-12-400 txt-black"
              >{{$t('multidisciplinary_board.lbl_file_name')}} <span class="text-danger">*</span></label
            >
            <input
              type="text"
              class="form-control txt-pri mb-0"
              v-model="name"
              :placeholder= "$t('multidisciplinary_board.lbl_enter_file_name')"
              @input="err_name = ''"
            />
            <p class="mb-3 robo-12-400 text-danger">{{ err_name }}</p>
            <p class="mb-2 robo-14-400 txt-pri">
              <span v-if="count">{{$t('multidisciplinary_board.lbl_selected')}} {{ count }} files</span>
            </p>
            <div class="upload-btn" @click="openInputDoc">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14.7369 2.76175H8.08489C6.00489 2.75375 4.30089 4.41075 4.25089 6.49075V17.2277C4.20589 19.3297 5.87389 21.0697 7.97489 21.1147C8.01189 21.1147 8.04889 21.1157 8.08489 21.1147H16.0729C18.1629 21.0407 19.8149 19.3187 19.8029 17.2277V8.03775L14.7369 2.76175Z"
                  stroke="#20419B"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M14.4756 2.75V5.659C14.4756 7.079 15.6246 8.23 17.0446 8.234H19.7986"
                  stroke="#20419B"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.6416 9.90918V15.9502"
                  stroke="#20419B"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M13.9869 12.2642L11.6419 9.90918L9.29688 12.2642"
                  stroke="#20419B"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <span class="robo-14-500 txt-pri"
                >{{$t('multidisciplinary_board.lbl_filetype_support')}}</span
              >
            </div>
            <p class="mb-3 robo-12-400 text-danger">{{ err_file }}</p>
          </div>
          <div class="modal-footer border-0 justify-content-center">
            <button
              type="button"
              class="btn bg-pri bd-pri text-white radius-10 w-100"
              @click="onFinishUpload()"
              :disabled="!name || !count"
            >
              {{$t('multidisciplinary_board.btn_up')}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <input
      type="file"
      ref="inputFile"
      accept=".jpeg, .png, .jpg, .gif, .svg, .doc, .docx, .pdf, .xls, .xlsx, .xlsm, .ppt, .pptx, .xlsm, .ppt, .pptx"
      @change="onSelectDoc($event)"
      multiple
      class="d-none"
    />
    <!-- //link -->
    <div
      class="modal fade"
      id="modalLink"
      tabindex="-1"
      aria-labelledby="modalLinkTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header border-0 bg-white mt-3 mb-0">
            <h5 class="ml-4 fs-18 fw-700 txt-black">{{$t('multidisciplinary_board.btn_add_link')}}</h5>
            <img
              src="../../../public/assets/images/icon/close-gray.svg"
              height="25px"
              class="cursor-pointer mr-3 mb-2"
              data-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label
                for="name"
                class="txt-greyscale-600 fs-16 fw-600 mb-2 required"
                >Link</label
              >
              <input
                v-model="form_link.link"
                type="text"
                class="form-control form-input border-custom bg-white mb-3"
              />
              <label for="name" class="txt-greyscale-600 fs-16 fw-600 mb-2"
                >{{$t('multidisciplinary_board.lbl_description')}}</label
              >
              <input
                v-model="form_link.name"
                type="text"
                class="form-control form-input border-custom bg-white"
              />
            </div>
          </div>
          <div class="modal-footer border-0 justify-content-center mb-2">
            <button
              type="button"
              class="btn bg-pri bd-pri text-white upload-btn2 radius-10 w-100"
              @click="onSubmitLink"
            >
              <!-- <span class="spinner-border mr-2" role="status">
                <span class="sr-only">Loading...</span>
              </span> -->
              {{$t('multidisciplinary_board.lbl_save')}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appUtils from '../../utils/appUtils'
export default {
  name: 'MDTDDocument',
  data () {
    return {
      exts: ['jpeg', 'png', 'jpg', 'gif', 'svg', 'doc', 'docx', 'pdf', 'xls', 'xlsx', 'xlsm', 'ppt', 'pptx'],
      selected_docs: [],
      name: '',
      err_name: '',
      err_file: '',
      img_exts: ['jpeg', 'png', 'jpg', 'gif', 'svg'],
      attachments: [],
      doctor_id: null,
      mdt_disease: null,
      form_link: {
        link: '',
        name: ''
      }
    }
  },
  computed: {
    docAttachments () {
      return this.attachments.filter(f => f.type === 1 || f.type === 2)
    },
    isOwner () {
      return this.doctor_id === this.mdt_disease?.doctor_id
    }
  },
  mounted () {
    this.showMdtDiseases()
    this.doctor_id = appUtils.getLocalUser()?.doctor?.id
  },
  methods: {
    async showMdtDiseases () {
      let self = this
      await self.$rf.getRequest('DoctorRequest').showMdtDiseases(this.$route.params.id).then((r) => {
        self.mdt_disease = r.data
        self.attachments = r.data.attachment
      })
    },
    onClose () {
      this.$router.push({ name: 'MdtDiseaseDetail', params: { id: this.$route.params.id } })
    },
    openInputDoc () {
      this.$refs.inputFile.click()
    },
    onSelectDoc (e) {
      const self = this
      const files = e.target.files
      self.err_file = ''
      console.log(files)
      let errFile = ''
      if (files) {
        for (let i = 0; i < files.length; i++) {
          const f = files[i]
          if (this.validateFile(f.name.split('.').pop())) {
            self.selected_docs.push(f)
          } else {
            errFile += (i + 1) + ','
          }
        }
      }
      self.handleClearInput()
      if (errFile) alert('File số ' + errFile.substring(0, errFile.length - 1) + ' không đúng định dạng nên đã bị loại bỏ')
    },
    validateFile (ext) {
      return this.exts.findIndex(e => e === ext.toLowerCase()) > -1
    },
    isImage (ext) {
      return this.img_exts.findIndex(e => e === ext.toLowerCase()) > -1
    },
    onFinishUpload () {
      if (!this.name) {
        this.err_name = this.$t('multidisciplinary_board.lbl_enter_name_sh')
        return
      }
      if (!this.selected_docs || !this.selected_docs.length) {
        this.err_file = this.$t('multidisciplinary_board.lbl_select_file_sh')
        return
      }
      this.onSubmitFiles(this.selected_docs, this.name)
    },
    getBase64URL (file) {
      return URL.createObjectURL(file)
    },
    getImageUrl (path) {
      return appUtils.getDocumentURL(path)
    },
    modalUpload (show) {
      window.$('#modalUpload').modal(show ? 'show' : 'hide')
    },
    modalCreateLink (show) {
      if (this.isOwner) window.$('#modalLink').modal(show ? 'show' : 'hide')
    },
    getLocalExtInfo (doc) {
      const result = {
        is_image: false,
        ext: ''
      }
      if (this.isImage(doc.name.split('.').pop())) {
        result.is_image = true
      } else {
        result.ext = doc.name.split('.').pop()
      }
      return result
    },
    getExtInfo (doc) {
      const result = {
        is_image: false,
        ext: ''
      }
      if (this.isImage(doc.url.split('.').pop())) {
        result.is_image = true
      } else {
        result.ext = doc.url.split('.').pop()
      }
      return result
    },
    handleClearInput () {
      this.$refs.inputFile.value = null
    },
    async onSubmitFiles (docs, name) {
      let self = this
      let params = {
        mdt_room_disease_id: this.$route.params.id
      }
      const formData = new FormData()
      for (var key in params) {
        formData.append(key, params[key])
      }
      docs.forEach((file, i) => {
        formData.append('data[' + i + '][name]', name || null)
        formData.append('data[' + i + '][file]', file)
        formData.append('data[' + i + '][type]', 1)
      })
      await self.$rf.getRequest('DoctorRequest').addMdtDiseasesFile(formData).then((r) => {
        self.showMdtDiseases()
        self.modalUpload(false)
        self.name = ''
        self.selected_docs = []
        return r
      })
    },
    async onSubmitLink (e) {
      let self = this
      e.target.disabled = true
      let params = {
        mdt_room_disease_id: this.$route.params.id,
        data: [
          {
            url: this.form_link.link,
            name: this.form_link.name,
            type: 2
          }
        ]
      }
      await self.$rf.getRequest('DoctorRequest').addMdtDiseasesFile(params).then((r) => {
        self.showMdtDiseases()
        self.modalCreateLink(false)
        self.form_link = {
          link: '',
          name: ''
        }
        return r
      }).finally(() => {
        e.target.disabled = false
      })
    },
    async deleteDoc (d) {
      let self = this
      let r = confirm(this.$t('multidisciplinary_board.lbl_confirm_delete'))
      if (!d || !r) return
      await this.$rf.getRequest('DoctorRequest').deleteMdtDiseaseAttach(d.id).then((r) => {
        self.showMdtDiseases()
      })
    },
    openDocAttach (doc) {
      if (doc.pac) {
        this.openPacs(doc.pac)
      } else {
        window.open(doc.url)
      }
    },
    formatDMY (dt) {
      return window.moment(dt).format('DD/MM/YYYY')
    },
    openPacs (p) {
      if (p.accession) this.getUrl(p.accession)
    },
    async getUrl (accession) {
      const self = this
      const params = {
        accession: accession
      }
      await self.$rf.getRequest('DoctorRequest').getUrlPac(params).then((r) => {
        if (r.data) {
          window.open(r.data)
        }
      })
    }
  }
}
</script>

<style scoped>
.item-doc {
  background: #eff2ff;
  border-radius: 10.5904px;
  cursor: pointer;
}
.item-doc-info {
  height: 76px;
  overflow: hidden;
}
.upload-btn {
  width: 100%;
  border: 0.756458px dashed #20409b;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  border-radius: 10px;
  cursor: pointer;
}
.form-control {
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-radius: 0;
  color: #20419b;
  padding-left: 0;
}
.radius-top-10 {
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}
.delete-btn {
  position: absolute;
  top: 6px;
  right: 12px;
  cursor: pointer;
}
</style>
